import { paymentsService } from "../../../services/payments";
import { useAct } from "../../../shared/hooks/useAct";
import { getAllEntries } from "../../../utils/serviceHelper";
import { useModalBulkApprove } from "../../components/NewPayablesTable/ModalBulkApprove";
import { useModalBulkPreApprove } from "../../components/NewPayablesTable/ModalBulkPreApprove";
import {
  API_QUERY_PAYABLES_DUAL_STAGE_TO_APPROVE,
  API_QUERY_PAYABLES_DUAL_STAGE_TO_PREAPPROVE,
  API_QUERY_PAYABLES_TO_APPROVE
} from "./apiQueries";

export function useApproveAll() {
  const modalBulkApprove = useModalBulkApprove();

  return useAct(async () => {
    const { filter, sort, page, ...other } = API_QUERY_PAYABLES_TO_APPROVE;

    const payables = await getAllEntries(
      async (...args) => {
        return (await paymentsService.payable.list(...(args as any))).data;
      },
      filter,
      sort,
      other
    );

    await modalBulkApprove.open({
      data: payables.map(payable => ({ payable }))
    });
  });
}

export function useDualStagePreapproveAll() {
  const modalBulkPreapprove = useModalBulkPreApprove();

  return useAct(async () => {
    const { filter, sort, page, ...other } =
      API_QUERY_PAYABLES_DUAL_STAGE_TO_PREAPPROVE;

    const payables = await getAllEntries(
      async (...args) => {
        return (await paymentsService.payable.list(...(args as any))).data;
      },
      filter,
      sort,
      other
    );

    await modalBulkPreapprove.open({
      data: payables.map(payable => ({ payable }))
    });
  });
}

export function useDualStageApproveAll() {
  const modalBulkApprove = useModalBulkApprove();

  return useAct(async () => {
    const { filter, sort, page, ...other } =
      API_QUERY_PAYABLES_DUAL_STAGE_TO_APPROVE;

    const payables = await getAllEntries(
      async (...args) => {
        return (await paymentsService.payable.list(...(args as any))).data;
      },
      filter,
      sort,
      other
    );

    await modalBulkApprove.open({
      data: payables.map(payable => ({ payable }))
    });
  });
}
